export default class Pagination {
  fullCount: number = 0;
  limit: number = 50;
  skip: number = 0;
  currentPage: number = 1;

  constructor() {

  }

  setPagination(data) {
    this.limit = data.limit;
    this.skip = data.skip;

    this.currentPage = (Math.trunc(this.skip / this.limit) + 1)
  }

  getQuery() {
    return {
      limit: this.limit,
      skip: this.skip,
    }
  }
}
